import { Link } from 'react-router-dom'

import s from './DetailsBox.module.css'

import TableItems from './table/TableItems'
import HeaderItems from './header/HeaderItems'
import SeparateLine from '../SeparateLine/SeparateLine'
import SecondaryButton from '../SecondaryButton/SecondaryButton'
import TitleBox from './Title/TitleBox'

const DetailsBoxItem = (props) => {
    const {
        title,
        footer,
        blocksInfos,
        warning,
        grid,
        divergency,
        gridReducer,
        editItemButton,
        isSearchPage,
        componentProps
    } = props

    const table = {
        isEditItem: gridReducer,
        isSearchPage,
        grid: grid?.grid,
        divergency: divergency ? divergency.grid : null,
        gridReducer
    }

    return (
        <section id={title.id} className={`${s.itensInfo} ${s[componentProps?.additionalClassName]}`}>

            <TitleBox title={title} />
            {Object.entries(blocksInfos).map(([k, v]) => (<HeaderItems key={k} items={v} />))}
            {footer && <TitleBox title={footer} />}


            {grid && <>
                <SeparateLine />
                <TableItems {...table} />
            </>}

            {warning && <p {...warning?.componentProps}>
                {warning.message}
                <Link to={warning?.link?.link || '.'}><span onClick={warning?.link?.click}>{warning?.link?.text}</span></Link>
            </p>}

            {
                editItemButton &&
                <div className={`${s.divergencyButton} ${s[props?.editItemButton?.componentProps?.additionalClassName]}`}>
                    <SecondaryButton onClick={editItemButton?.click} additionalClassName="button__SecondaryButton--conteiner_inherit">
                        <Link className={s.divergencyButtonContent} to={editItemButton?.link || '#'}>
                            {editItemButton?.Icon}
                            <span>{editItemButton?.text}</span>
                        </Link>
                    </SecondaryButton>
                </div>
            }
        </section >

    )
}

export default DetailsBoxItem